<template>
<div class="max-width-3 mx-auto px2 mb3">
    <lightbox :activateCommand="'show_musicwish_lightbox'" :deactivateCommand="'close_musicwish_lightbox'" customClass="bg-color-white max-width-2">
      <sms-checker :phone_nr="phone_nr" :user_name="user_name" :dsgvo="dsgvo" :checkerParent="'musicwish'" :success="'song'"/>
    </lightbox>
    <lightbox :activateCommand="'show_song_sent_lightbox'" :deactivateCommand="'close_song_sent_lightbox'" customClass="bg-color-white max-width-2">
      <h2>Vielen Dank für deinen Vorschlag! Dein Songwunsch wurde auf die Wunschliste gesetzt.</h2>
      <button class="btn btn-primary mt4" @click="EBusEmit('close_song_sent_lightbox')">OK!</button>
    </lightbox>
    <lightbox :activateCommand="'show_blacklist_lightbox'" :deactivateCommand="'close_blacklist_lightbox'" customClass="bg-color-white">
      <h2>Diese Handynummer wurde gesperrt und kann keine Nachrichten mehr verschicken.</h2>
      <button class="btn btn-primary mt4" @click="EBusEmit('close_blacklist_lightbox')">OK</button>
    </lightbox>
    <headline link="/" headline="Wünsch dir deinen Lieblingssong!" />
    <div class="form-wrapper pt2" v-if="isTime">
      <div class="mb3 relative">
        <input class="n8-input" v-model="music_title" required :class="{ error: not_filled_music_title }">
        <span class="floating-label">Musikwunsch*</span>
      </div>
      <div class="mb3 relative">
        <input class="n8-input" v-model="phone_nr" required :class="{ error: not_filled_phone_nr }">
        <span class="floating-label">Handynummer*</span>
      </div>
      <div class="mb3 relative">
        <input class="n8-input" v-model="user_name" required :class="{ error: not_filled_user_name }">
        <span class="floating-label">Username*</span>
      </div>
      <div class="flex align-middle mb2 mt3">
        <input class="checkbox-input mr2" type="checkbox" v-model="dsgvo">
        <label class="pointer"  :class="{ error: not_filled_dsgvo }">Ich akzeptiere die Datenschutzbedingungen*</label>
      </div>
      <div class="flex align-middle mb2 mt3">
        <input class="checkbox-input mr2" type="checkbox" v-model="receive_newsletter">
        <label class="pointer">Ja, ich möchte den SMS-Newsletter abonnieren</label>
      </div>
      <div v-if="!allIsValidated" class="error-msg">Bitte fülle alle Pflichtelder aus.</div>
      <div class="mt3">
        <button class="btn btn-primary" @click="validateInput()">Absenden</button>
      </div>
      <p class="mt3 color-gray max-width-2 p-small">Bitte sei nicht enttäuscht, falls dein Song nicht oder nicht sofort gespielt wird. Es gehen viele Wünsche ein und der DJ hat das letzte Wort, wenn es um die Songs geht, die gespielt werden.</p>
    </div>
    <div v-if="!isTime">
    <p class="px4 mx1">Im Moment können keine Musikwünsche abgegeben werden! Immer Freitags und Samstags von 18:00 Uhr bis 6:00 könnt ihr den DJs eure Wünsche mitteilen.</p>
    </div>
</div>
</template>
<script>
import Headline from './Headline.vue';
import Lightbox from './GeneralLightbox.vue';
import SMSChecker from './SMSChecker.vue';
import { EventBus } from '../event-bus.js';
import axios from 'axios';
import { apiUrl } from '../api';
export default {
  name: "MusicWishlist",
  data() {
    return {
      session: {},
      music_title: '',
      phone_nr: '',
      user_name: '',
      dsgvo: false,
      receive_newsletter: false,


      not_filled_music_title: false,
      not_filled_phone_nr: false,
      not_filled_user_name: false,
      not_filled_dsgvo: false,

      allIsValidated: true,

      isTime: false
    };
  },
  components: {
    'headline': Headline,
    'lightbox': Lightbox,
    'sms-checker': SMSChecker
  },
  created(){
    EventBus.$on('sendSession_Component', (payload) => {
      console.log('Received Session from App')
      console.log(payload)
      this.session = payload.session
    });
    EventBus.$on('sendUser_Component', (payload) => {
      console.log('Received User from App')
      console.log(payload)
      this.user_name = payload.user.user_name;
      this.phone_nr = payload.user.phone_nr;
      this.dsgvo = payload.user.dsgvo;
    });
    this.calculateTime();
    EventBus.$on('clear_song', () => {
      this.music_title = '';
    })
  },
  mounted(){
    console.log('Component Initialized, requesting Session')
    EventBus.$emit('requestSession_Component')
    EventBus.$emit('requestUser_Component')
  },
  methods: {
      EBusEmit(command){
        EventBus.$emit(command)
      },
    calculateTime(){
      // timer for updating
      let self = this;
      let seconds = 0;

      //Initial Timecheck
      var objDate = new Date();
      var hours = objDate.getHours();
      var day = objDate.getDay();
      if(hours < 6 || hours > 17 && day == 5 || day == 6){
          self.isTime = true;
      }else{
          self.isTime = false;
      }

      function getTime() {
          seconds++; 
          if (seconds === 60) {
            var objDate = new Date();
            var hours = objDate.getHours();
            var day = objDate.getDay();
            if(hours < 6 || hours > 17 && day == 5 || day == 6){
                self.isTime = true;
            }else{
                self.isTime = false;
            }
            seconds = 0; //reset timer   
          }
        }
        setInterval(getTime, 1000); 
    },
      validateInput(){
        this.allIsValidated = true;

        this.not_filled_music_title = false;
        this.not_filled_phone_nr = false;
        this.not_filled_user_name = false;
        this.not_filled_dsgvo = false;

        if(this.music_title == ''){
            this.allIsValidated = false;
            this.not_filled_music_title = true;
        }
        if(this.phone_nr == ''){
            this.allIsValidated = false;
            this.not_filled_phone_nr = true;
        }
        if(this.user_name == ''){
            this.allIsValidated = false;
            this.not_filled_user_name = true;
        }
        if(this.dsgvo == false){
          this.allIsValidated = false;
          this.not_filled_dsgvo = true;
        }
        if(this.allIsValidated == true){
            //send form data
            console.log('All is validated')
            // let that = this;
            let url =  apiUrl('/public-api/set/wishlist/json');
            let data = {};
            data.songname = this.music_title;
            data.mobilephone = this.phone_nr;
            data.newsletteroptin = this.receive_newsletter;
            data.name = this.user_name;
            if(this.session.validation_crypt !== undefined){
              data.validation_crypt = this.session.validation_crypt;
            }
            axios.post(url, data)
              .then(response => {
                console.log('Response from Music-Wishlist Call:')
                console.log(response);      
                if(response.data.isValidated == false && response.data.isBlacklisted == false){
                  console.log('User not validated. Opening SMSChecker...')
                  console.log('Sending Session to SMSChecker')
                  EventBus.$emit('sendSession_not_validated', {
                    'validation_crypt': response.data.validation_crypt,
                    'validation_id': response.data.validation_id, 
                    'validation_object': response.data.validation_object 
                  });
                  EventBus.$emit('show_musicwish_lightbox');
                }
                if(response.data.isValidated == true){
                  console.log('Wishlist Call successful Sending Validation Session to App')
                  EventBus.$emit('send_validation', {
                    'validation_crypt': response.data.validation_crypt,
                    'validation_id': response.data.validation_id, 
                    'validation_object': response.data.validation_object 
                  });
                  console.log('Sending User to App')
                  EventBus.$emit('send_user', {
                    'user_name': this.user_name,
                    'phone_nr': this.phone_nr,
                    'dsgvo': this.dsgvo
                  });
                  console.log('User is validated. Everything is fine.')
                  this.music_title = '';
                  EventBus.$emit('show_song_sent_lightbox');
                }
                if(response.data.isBlacklisted == true){
                  console.log('User is Blacklisted. GTFO OF HERE')
                  EventBus.$emit('show_blacklist_lightbox')
                }
              })
              .catch(function () {
                  //console.log('catch Function of AJAX-Called... userprofileError()');
              });
        }
      }
  }
}
</script>
<style>

</style>
